var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ padding: '0 0 32px 32px' })},[_c('h4',{style:({ marginBottom: '20px' })},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticStyle:{"width":"auto","height":"400px"},attrs:{"id":"chart_example"}})])}
var staticRenderFns = []

export { render, staticRenderFns }